import script from "./client-estimate.vue?vue&type=script&setup=true&lang=js"
export * from "./client-estimate.vue?vue&type=script&setup=true&lang=js"

import "./client-estimate.vue?vue&type=style&index=0&id=3212479d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3212479d"]])

export default __exports__